import { BaseTransformationVisitor } from './baseTransformation.visitor';
import { SchemaUtil } from '../utils/schema.util';
import { CastPlainObject } from '../plainObjects/cast.plainObject';

export class CastVisitor extends BaseTransformationVisitor {

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    public visitOutputDefinition(outputDefinitionContext: any): void {
        (this.transformation as CastPlainObject).columns = SchemaUtil.getSchemaFromInputOutputDefinition(outputDefinitionContext);
    }
}
